module.exports = __webpack_public_path__ + "img/chandao.84dd4df3.png";